
<template lang="pug">
  .tabs
    .tabs__nav(v-if="$mq !== 'mobile'")
      button.tabs__nav__button(
        type="button", 
        v-for="tab in tabs", 
        :class="{ 'active': tab.active }", 
        @click="activate(tab)"
      ) {{ tab.heading }}
    .tabs__content
      slot
</template>

<script>
  export default {
    name: 'Tabs',
    data() {
      return {
        tabs: []
      }
    },
    methods: {
      addTab(newTab) {
        this.tabs.push(newTab)
      },
      removeTab(tab) {
        let index = this.tabs.findIndex(t => t.heading === tab.heading)
        this.tabs.splice(index, 1)
      },
      activate({ heading }) {
        this.tabs.forEach(function (tab) {
          tab.active = Boolean(heading === tab.heading)
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .tabs {
    &__nav {
      border-bottom: 2px solid $color--primary;
      margin-bottom: $content-gutter;
      text-align: center;

      &__button {
        cursor: pointer;
        background-color: transparent;
        position: relative;
        margin: 0;
        line-height: 1.5;
        letter-spacing: 3px;
        padding: 27px;
        border: none;
        font-weight: 900;
        color: $text--main;
        transition: 0.3s ease all;
        font-size: rem(14);
        line-height: 1.28;
        text-transform: uppercase;

        &:hover {
          color: $color--primary;
        }

        &.active {
          color: $color--primary;
        }
      }
    }
  }
</style>
